import weekIcon from 'src/public/img/illustration-communication.svg';
import congratulationsIcon from 'src/public/img/illustration-smiley-face.svg';

import { ProgramSharedStep, ProgramWeekEnum } from 'src/modules/programs/models/programs';

import { CBTProgramStepProps } from '../../models/cbtProgram';
import { MoreAboutEmotionsStep } from '../stepComponents/MoreAboutEmotionsStep';
import { TheConsequencesStep } from '../stepComponents/TheConsequencesStep';
import { TheExperienceOfAnEmotionStep } from '../stepComponents/TheExperienceOfAnEmotionStep';
import { TheLifecycleOfAnEmotionStep } from '../stepComponents/TheLifecycleOfAnEmotionStep';
import { TheLifecycleOfYourEmotionStep } from '../stepComponents/TheLifecycleOfYourEmotionStep';
import { TheStartOfAnEmotionStep } from '../stepComponents/TheStartOfAnEmotion';
import { TrackYourEmotionsStep } from '../stepComponents/TrackYourEmotionsStep';
import { UnderstandYourEmotionStep } from '../stepComponents/UnderstandYourEmotionStep';
import { WhatPurposeHaveEmotionsStep } from '../stepComponents/WhatPurposeHaveEmotionsStep';
import { WhereDoEmotionsStartStep } from '../stepComponents/WhereDoEmotionsStartStep';
import { CBTProgramWeekThreeStep } from './weekThree';

const steps: (ProgramSharedStep | CBTProgramWeekThreeStep)[] = [
    ProgramSharedStep.WellbeingCheckInStep,
    ProgramSharedStep.WellbeingScoreStep,
    ProgramSharedStep.FeedbackStep,
    CBTProgramWeekThreeStep.MoreAboutEmotionsStep,
    CBTProgramWeekThreeStep.WhatPurposeHaveEmotionsStep,
    CBTProgramWeekThreeStep.TheLifecycleOfAnEmotionStep,
    CBTProgramWeekThreeStep.TheStartOfAnEmotionStep,
    CBTProgramWeekThreeStep.TheExperienceOfAnEmotionStep,
    CBTProgramWeekThreeStep.WhereDoEmotionsStartStep,
    CBTProgramWeekThreeStep.TheConsequencesStep,
    CBTProgramWeekThreeStep.TheLifecycleOfYourEmotionStep,
    CBTProgramWeekThreeStep.UnderstandYourEmotionStep,
    ProgramSharedStep.PlanStep,
    ProgramSharedStep.CongratulationsStep,
];

const stepsProps: CBTProgramStepProps[] = [
    {
        id: CBTProgramWeekThreeStep.MoreAboutEmotionsStep,
        component: MoreAboutEmotionsStep,
        tooltip: 'More about emotions',
    },
    {
        id: CBTProgramWeekThreeStep.WhatPurposeHaveEmotionsStep,
        component: WhatPurposeHaveEmotionsStep,
        tooltip: 'What purpose have emotions served for you?',
        noButtons: true,
        grayBackground: true,
    },
    {
        id: CBTProgramWeekThreeStep.TheLifecycleOfAnEmotionStep,
        component: TheLifecycleOfAnEmotionStep,
        tooltip: 'The lifecycle of an emotion',
        flexGrow: false,
    },
    {
        id: CBTProgramWeekThreeStep.TheStartOfAnEmotionStep,
        component: TheStartOfAnEmotionStep,
        tooltip: 'The start of an emotion...',
        noButtons: true,
        grayBackground: true,
    },
    {
        id: CBTProgramWeekThreeStep.TheExperienceOfAnEmotionStep,
        component: TheExperienceOfAnEmotionStep,
        tooltip: 'The experience of an emotion',
    },
    {
        id: CBTProgramWeekThreeStep.WhereDoEmotionsStartStep,
        component: WhereDoEmotionsStartStep,
        tooltip: 'Where do emotions start?',
    },
    {
        id: CBTProgramWeekThreeStep.TheConsequencesStep,
        component: TheConsequencesStep,
        tooltip: 'The consequences of a response…',
    },
    {
        id: CBTProgramWeekThreeStep.TheLifecycleOfYourEmotionStep,
        component: TheLifecycleOfYourEmotionStep,
        tooltip: 'The lifecycle of your emotion',
        flexGrow: false,
    },
    {
        id: CBTProgramWeekThreeStep.UnderstandYourEmotionStep,
        component: UnderstandYourEmotionStep,
        tooltip: 'Understand your emotion',
        noButtons: true,
        grayBackground: true,
    },
    {
        id: ProgramSharedStep.PlanStep,
        component: TrackYourEmotionsStep,
        tooltip: 'Track your emotions',
        flexGrow: false,
    },
];

const t = (key: string) => `cbt:week-3.data.${key}`;

export const weekThreeData = {
    id: ProgramWeekEnum.WeekThree,
    weekNumber: 2,
    readableWeekNumber: 3,
    iconUrl: weekIcon,
    congratulationsIconUrl: congratulationsIcon,
    title: t('title'),
    congratulationsSneakPeek: t('congratulationsSneakPeek'),
    feedbackPlaceholder: t('feedbackPlaceholder'),
    greetingModalContent: t('greetingModalContent'),
    steps,
    stepsProps,
};
